import { ValidationOfProposals } from './pages/validationOfProposalsList';
import { ValidationOfProposalsForm } from './pages/validationOfProposalsForm';

export const ValidationOfProposalsRoutes = [
  {
    path: '/pre-proposta',
    exact: true,
    component: ValidationOfProposals,
  },
  {
    path: '/pre-proposta/edit/:id',
    component: ValidationOfProposalsForm,
  },
];
